import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";
import {
  Column,
  Columns, Div, Dropdown,
  DropdownMenu,
  Icon,
  IconText, P
} from "trunx";

import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { observer } from "mobx-react-lite";
import config from "../../config";
import { useLocaleContext } from "../../contexts/LocaleContext";
import { useRootStore } from "../../models/Root";
import { SensorDisplayPrecip, SensorDisplayStream } from "../../models/SensorDisplay";

const SelectSensorFilter = () => {
  const {
    dict: {
      intervals: { durationLabel, lastLabel, max },
      panel: {
        sensors: { data: dict },
      },
    },
  } = useLocaleContext();

  const {
    sensors: {
      display,
      clearDisplay,
      displayPrecipWithInterval,
      displayStreamWithPeriod,
    },
  } = useRootStore();

  interface PrecipCheckboxProps {
    interval: string;
  }
  const PrecipCheckbox = observer(({ interval }: PrecipCheckboxProps) => {
    const isSelected =
      SensorDisplayPrecip.is(display) && display.interval === interval;

    return (
      <li
        onClick={() =>
          isSelected ? clearDisplay() : displayPrecipWithInterval(interval)
        }
      >
        <IconText>
          <Icon bulma="is-left">
            <FontAwesomeIcon icon={isSelected ? faCheckSquare : faSquare} />
          </Icon>
          {durationLabel[interval]}
        </IconText>
      </li>
    );
  });

  interface StreamCheckboxProps {
    period: string;
  }
  const StreamCheckbox = observer(({ period }: StreamCheckboxProps) => {
    const isSelected =
      SensorDisplayStream.is(display) && display.period === period;
    return (
      <li
        onClick={() =>
          isSelected ? clearDisplay() : displayStreamWithPeriod(period)
        }
      >
        <IconText>
          <Icon bulma="is-left">
            <FontAwesomeIcon icon={isSelected ? faCheckSquare : faSquare} />
          </Icon>
          {period === "last" ? lastLabel : `${durationLabel[period]} ${max}`}
        </IconText>
      </li>
    );
  });

  return (
    <Columns bulma="is-mobile">
      <Column id="precip-col" bulma="is-half">
        <Div bulma="menu">
          <P bulma="menu-label">{dict.precip}</P>
          <ul className="menu-list">
            {config.precipIntervals.base.map((interval) => (
              <PrecipCheckbox key={interval} interval={interval} />
            ))}
            <li>
              <Dropdown isHoverable>
                <div className="dropdown-trigger">
                  <IconText>
                    <Icon bulma="is-left">
                      <FontAwesomeIcon icon={faAngleDown} />
                    </Icon>
                    {dict.other}
                  </IconText>
                </div>
                <DropdownMenu>
                  <Div bulma="dropdown-content">
                    <ul>
                      {config.precipIntervals.more.map((interval) => (
                        <PrecipCheckbox key={interval} interval={interval} />
                      ))}
                    </ul>
                  </Div>
                </DropdownMenu>
              </Dropdown>
            </li>
          </ul>
        </Div>
      </Column>
      <Column bulma="is-half">
        <Div bulma="menu">
          <P bulma="menu-label">{dict.stream}</P>
          <ul className="menu-list">
            <StreamCheckbox period="last" />
            <StreamCheckbox period="PT6H" />
            <StreamCheckbox period="PT12H" />
            <StreamCheckbox period="P1D" />
          </ul>
        </Div>
      </Column>
    </Columns>
  );
};

export default observer(SelectSensorFilter);
